import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import { parse, differenceInYears } from 'date-fns';

export const isValidDob = (minAge, maxAge, dob, policyStartDate) => {
  if (isValid(parseISO(dob))) {
    const parsedPolicyStartDate = parse(
      policyStartDate,
      'yyyy-MM-dd',
      new Date(),
    );

    const parsedDOB = parse(dob, 'yyyy-MM-dd', new Date());
    if (
      differenceInYears(parsedPolicyStartDate, parsedDOB) >= minAge &&
      differenceInYears(parsedPolicyStartDate, parsedDOB) <= maxAge
    ) {
      return true;
    }
  }
  return false;
};

export const isValidDateFormat = (dob) => {
  const pattern = /^\d{4}-\d{2}-\d{2}$/;
  return pattern.test(dob) && isValid(parseISO(dob));
};

export const minusNbOfYearsFrom = (fromDate, nbOfYears) => {
  const defaultDate = new Date(Date.parse(fromDate));
  defaultDate.setFullYear(defaultDate.getFullYear() - nbOfYears);
  return defaultDate;
};

export const getAgeDifferenceToPolicyStartDate = (policyStartDate, dob) =>
  differenceInYears(
    parse(policyStartDate, 'yyyy-MM-dd', new Date()),
    parse(dob, 'yyyy-MM-dd', new Date()),
  );
